import styled from 'styled-components';

const DashedList = styled.ul`
  list-style-type: none;

  li {
    text-indent: 8px;
  }

  li:before {
    content: '- ';
  }
`;

export default DashedList;
